/* Add to Cart cheers (Hagan 2026-10-19): when an item lands in the cart
   from a labelled Add to Cart button (product page or quick-buy drawer),
   the button shows a random message from Theme settings > GLO: Add to Cart
   cheers for ~1.2s, THEN the cart drawer opens.

   How: the theme's ProductForm dispatches `shapes:cart:afteradditem` on
   <body>; the cart drawer, cart count, line items and footer all listen
   for it there or on window. A capture listener on document runs before
   any of them, stops the event, shows the cheer, and re-dispatches an
   identical event after the pause - so everything downstream runs
   unchanged, just a beat later. Icon-only card buttons have no room for
   text and keep adding instantly. */

(function () {
  var data = document.getElementById('gp-atc-cheers');
  if (!data) return;
  var cheers = [];
  try { cheers = JSON.parse(data.textContent).map(function (c) { return c.trim(); }).filter(Boolean); } catch (e) { return; }
  if (!cheers.length) return;

  var HOLD = 1200;
  var last = -1;
  function pick() {
    var i = Math.floor(Math.random() * cheers.length);
    if (cheers.length > 1 && i === last) i = (i + 1) % cheers.length;
    last = i;
    return cheers[i];
  }

  // the button the shopper actually tapped (PDP main or sticky, quick-buy)
  var tapped = null;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.add-to-cart-btn');
    if (b) tapped = b;
  }, true);

  function buttonFor(formId) {
    var b = tapped;
    tapped = null;
    if (!b || !formId) return null;
    var form = document.getElementById(formId);
    var belongs = b.getAttribute('form') === formId || (form && form.contains(b));
    var surf = b.querySelector('.push-btn__surface');
    // labelled buttons only - icon-only card buttons have no room
    if (!belongs || !surf || !surf.textContent.trim()) return null;
    return b;
  }

  function cheer(btn, text) {
    var surf = btn.querySelector('.push-btn__surface');
    var old = surf.querySelector('.gp-cheer');
    if (old) old.remove();
    var el = document.createElement('span');
    el.className = 'gp-cheer';
    el.setAttribute('role', 'status');
    el.textContent = text;
    surf.appendChild(el);
    surf.classList.add('gp-cheer-on');
    setTimeout(function () {
      surf.classList.remove('gp-cheer-on');
      el.remove();
    }, HOLD + 1600); // stays up while the drawer slides over it
  }

  document.addEventListener('shapes:cart:afteradditem', function (e) {
    if (e.__gpReplay) return;
    var btn = buttonFor(e.detail && e.detail.sourceId);
    if (!btn) return;
    e.stopPropagation();
    cheer(btn, pick());
    var detail = e.detail;
    setTimeout(function () {
      var replay = new CustomEvent('shapes:cart:afteradditem', { bubbles: true, detail: detail });
      replay.__gpReplay = true;
      document.body.dispatchEvent(replay);
    }, HOLD);
  }, true);
})();
